import {Component, inject, output} from '@angular/core';
import {Router} from '@angular/router';

import {PowerStopService} from '@core/services/power-stop.service';

@Component({
  selector: 'app-add-to-cart-popup',
  templateUrl: './add-to-cart-popup.component.html',
  styleUrls: ['./add-to-cart-popup.component.scss'],
  imports: []
})
export class AddToCartPopupComponent {
  private router = inject(Router);
  private powerStopService = inject(PowerStopService);


  readonly buyMore = output();

  goToCheckout() {
    this.powerStopService.goToPowerStop('addToCartPopup');
  }

  notOnCartPage() {
    return this.router.url !== '/checkout/cart';
  }

}
